import "./Preview.css";

import { ReactComponent as CrossInCircleIcon } from "shared/assets/cross-in-circle.svg";
import { Content, Leaderboard } from "shared/request/myHealthyAdvantageApi";
import { DatoContent } from "UIPalette/Components/DatoContent/DatoContent";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { PropsWithChildren } from "react";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";

export type LeaderboardPreview = {
  leaderboard: Leaderboard;
  durationText: string;
  startDate: Date;
  endDate: Date;
};

export type PreviewProps = {
  name: string;
  content: Content;
  subtitle: string;
  onClose?: () => void;
};
export const Preview = ({ name, content, subtitle, onClose, children }: PreviewProps & PropsWithChildren) => {
  return (
    <>
      <PageHeader narrowView title={name} subtitle={subtitle} onClickBack={onClose} backIcon={CrossInCircleIcon} backTitle="Close" />
      <NarrowContainer>
        <DatoContent className="flex-grow" content={content} />
        {children}
      </NarrowContainer>
    </>
  );
};
